import { useEffect, useRef, useState } from "react";
import { FileUpload, FileUploadButton } from "../../components/FileUpload";
//import { getAnalytics } from "firebase/analytics";

const UploadPage = (props) => {
  const [uploadList, setUploadList] = useState([]);
  const [name, setName] = useState(localStorage.getItem("user_nickname") || "");

  const handleFiles = (newFiles) => {
    localStorage.setItem("user_nickname", name);

    setUploadList([...uploadList, ...newFiles]);
  };

  console.log(uploadList);

  return (
    <div
      style={{
        width: "90%",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      <div
        style={{
          backgroundColor: "rgba(128,128,128,.5)",
          padding: "20px",
          margin: "10px 0",
          borderRadius: "10px",
        }}
      >
        <h1>Photo Upload</h1>
        <p>
          Have pictures to share? Upload them here!
          <br />
          <em>
            Pictures you have previously shared will not show on this screen.
            <br />
            This may struggle with some larger files such as videos.
          </em>
        </p>
        <label htmlFor="nameInput" className="form-label">
          Enter Your Name
        </label>
        <br />
        <input
          id="nameInput"
          className="form-control"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
          }}
        />
        <br />
        <FileUploadButton
          collection="bluff_activities"
          onFiles={handleFiles}
          fileProperties={{ uploader: name, uid: localStorage.getItem("uid") }}
        >
          Upload Photos
        </FileUploadButton>
      </div>
      {uploadList.map((element, index) => {
        return (
          <FileUpload
            key={`upload_${index}`}
            file={element.file}
            style={{
              backgroundColor: "rgba(128,128,128,.5)",
              padding: "20px",
              margin: "10px 0",
              borderRadius: "10px",
            }}
            fileProperties={element.fileProperties}
            collection={element.collection}
          />
        );
      })}
    </div>
  );
};

export { UploadPage };
